<!--
  创建时间：2024/8/23 17:09
  创建人：toyehuang
  文件描述：DataStats 统计数据
-->

<template>
  <ul class="data-stats mt-20 f-b-c">
    <li class="item yhzs">
      <p class="fc33">{{ membersNumber }}</p>
      <span class="fc99">入驻会员(家)</span>
      <ul class="item-pop flex-column-center">
        <li class="pop-item flex">
          <p class="fc33">招采单位：</p>
          <span class="color-theme-red">{{ info.purchaseUnitNumber.toLocaleString('en-US') }} 家</span>
        </li>
        <li class="pop-item flex">
          <p class="fc33">代理机构：</p>
          <span class="color-theme-red">{{ info.purchaseOrgNumber.toLocaleString('en-US') }} 家</span>
        </li>
        <li class="pop-item flex">
          <p class="fc33">评委专家：</p>
          <span class="color-theme-red">{{ info.raterNumber.toLocaleString('en-US') }} 位</span>
        </li>
        <li class="pop-item flex">
          <p class="fc33">供应商：</p>
          <span class="color-theme-red">{{ info.supplierNumber.toLocaleString('en-US') }} 家</span>
        </li>
      </ul>
    </li>

    <li class="item cjxm">
      <p class="fc33">{{ info.dealNumber.toLocaleString('en-US') }}</p>
      <span class="fc99">成交项目(宗)</span>
    </li>
    <li class="item cjje">
      <p class="fc33">{{ info.dealAmountFormat }}</p>
      <span class="fc99">成交金额(万元)</span>
    </li>
    <li class="item jyzj">
      <p class="fc33">{{ info.economyAmountFormat }}</p>
      <span class="fc99">节约资金(万元)</span>
    </li>
  </ul>
</template>

<script>
import statisticsApi from "@/api/statistics";

export default {
  name: "DataStats",
  components: {},
  props: {
  },
  data() {
    return {
      info: {
        // 采购单位
        purchaseUnitNumber: 0,
        // 代理机构
        purchaseOrgNumber: 0,
        // 评委专家
        raterNumber: 0,
        // 供应商
        supplierNumber: 0,
        // 成交项目
        dealNumber: 0,
        // 成交金额
        dealAmountFormat: "0.00",
        // 节约资金
        economyAmountFormat: "0.00"
      }
    };
  },
  // 监听属性 类似于data概念
  computed: {
    // 入驻会员 = 供应商数+招采单位数+代理机构数+评委专家数
    membersNumber() {
      const number = parseInt(this.info.supplierNumber + this.info.purchaseUnitNumber + this.info.purchaseOrgNumber + this.info.raterNumber);
      return number.toLocaleString("en-US")
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getData()
  },
  // 方法集合
  methods: {
    getData() {
      statisticsApi.getNewest().then((res) => {
        this.info = res.data;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.data-stats{
  width: 100%;
  height: 100px;
  border: 2px solid $--color-primary;
  padding:0 20px;
	position: relative;
	z-index: 9;
  .item{
    padding:22px 0 20px 60px;
    position: relative;
		flex: 1;
		height: 100%;
		& + .item{
			margin-left: 20px;
		}
    &:before{
      content: '';
      display: block;
      width: 50px;
      height: 50px;
      position: absolute;
      left: 0;
      background-size: 100%;
      background-position: center;
    }
    &.yhzs:before{
      background-image: url("@/assets/images/home/yhzs.png");
    }
    &.cjxm:before{
      background-image: url("@/assets/images/home/cjxm.png");
    }
    &.cjje:before{
      background-image: url("@/assets/images/home/cjje.png");
    }
    &.jyzj:before{
      background-image: url("@/assets/images/home/jyzj.png");
    }

    p{
      font-size: 30px;
      line-height: 1;
      font-weight: bold;
    }
    span{
      font-size: 14px;
    }
		.item-pop{
			position: absolute;
			left: -22px;
			top: 100%;
			border: 2px solid $--color-primary;
			background-color: #fff;
			width: calc(100% + 20px);
			z-index: 999;
			height: 0;
			overflow: hidden;
			opacity: 0;
			transition: all 0.3s;
			.pop-item {
				p {
					flex: 1;
					text-align: right;
					font-weight: normal;
					font-size: 14px;
					line-height: 28px;
				}
				span {
					flex: 1;
					text-align: left;
					font-weight: normal;
					font-size: 14px;
					line-height: 28px;
				}
			}
		}
		&:hover{
			.item-pop{
				opacity: 1;
				height: 132px;
			}
		}
  }
}
</style>
